import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import { fmt } from '../../utils/calc';
import './Modal.css';
import './Financial.css';

export default function FinancialModal({ onClose }) {
  const { data } = useApp();
  const [period, setPeriod] = useState('mois');

  const now = new Date();
  function inPeriod(dateStr) {
    const d = new Date(dateStr);
    if (period === 'tout')  return true;
    if (period === 'jour')  return d.toDateString() === now.toDateString();
    if (period === 'mois')  return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
    if (period === 'annee') return d.getFullYear() === now.getFullYear();
    return true;
  }

  const filtered  = data.transactions.filter(t => inPeriod(t.date));
  const factures  = filtered.filter(t => t.type === 'facture');
  const devis     = filtered.filter(t => t.type === 'devis');
  const totalFact = factures.reduce((s, t) => s + t.total, 0);
  const totalDevis= devis.reduce((s, t) => s + t.total, 0);
  const acomptes  = factures.reduce((s, t) => s + t.acompte, 0);
  const restants  = factures.reduce((s, t) => s + t.restant, 0);

  const periodLabel = { jour:"Aujourd'hui", mois:"Ce mois", annee:"Cette année", tout:"Total général" }[period];

  function exportCSV() {
    const lines = ['Type,Numéro,Client,Total,Acompte,Restant,Émis par,Date'];
    data.transactions.forEach(t => {
      lines.push([t.type,t.num,t.client,t.total,t.acompte,t.restant,t.worker,t.dateStr].join(','));
    });
    const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `kotos-finances-${period}-${now.toISOString().split('T')[0]}.csv`;
    a.click();
  }

  return (
    <div className="overlay open">
      <div className="modal" style={{ maxWidth: 900 }}>
        <div className="mhead">
          <h2>📊 Tableau de Bord Financier</h2>
          <div style={{ display:'flex', gap:8, alignItems:'center' }}>
            <select value={period} onChange={e=>setPeriod(e.target.value)} className="period-sel">
              <option value="jour">Aujourd'hui</option>
              <option value="mois">Ce mois</option>
              <option value="annee">Cette année</option>
              <option value="tout">Tout</option>
            </select>
            <button className="abtn abtn-gold" onClick={exportCSV} style={{fontSize:10,padding:'6px 12px'}}>⬇ CSV</button>
            <button className="mclose" onClick={onClose}>✕</button>
          </div>
        </div>
        <div className="mbody">
          <p className="period-label">Période : <strong>{periodLabel}</strong> · {filtered.length} opération(s)</p>

          {/* KPI cards */}
          <div className="fin-dash">
            <div className="fin-card">
              <div className="fc-label">💰 Chiffre Facturé</div>
              <div className="fc-value green">{fmt(totalFact)}</div>
              <div className="fc-sub">{factures.length} facture(s)</div>
            </div>
            <div className="fin-card">
              <div className="fc-label">📋 Devis Émis</div>
              <div className="fc-value gold">{fmt(totalDevis)}</div>
              <div className="fc-sub">{devis.length} devis</div>
            </div>
            <div className="fin-card">
              <div className="fc-label">✅ Acomptes Reçus</div>
              <div className="fc-value green">{fmt(acomptes)}</div>
              <div className="fc-sub">Sur factures</div>
            </div>
            <div className="fin-card">
              <div className="fc-label">⏳ Reste à Encaisser</div>
              <div className="fc-value red">{fmt(restants)}</div>
              <div className="fc-sub">Créances en cours</div>
            </div>
          </div>

          {/* Transactions table */}
          {filtered.length === 0 ? (
            <div className="no-tx">📊 Aucune transaction pour cette période.<br /><span>Générez des factures et devis pour les voir ici.</span></div>
          ) : (
            <div className="trans-list">
              <div className="trans-header">
                <span>Date</span><span>Client / Ref.</span><span>Type</span><span>Montant</span><span>Émis par</span>
              </div>
              {[...filtered].reverse().map(t => (
                <div key={t.id} className="trans-row">
                  <div className="trans-date">{t.dateStr}</div>
                  <div><div className="trans-client">{t.client}</div><div className="trans-ref">{t.num}</div></div>
                  <div><span className={`trans-badge ${t.type === 'facture' ? 'tb-fact' : 'tb-devis'}`}>{t.type.toUpperCase()}</span></div>
                  <div className="trans-amount">{t.total.toLocaleString('fr-FR')} F</div>
                  <div className="trans-worker">{t.worker}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
